import React from "react";
import { Link } from "react-router-dom";

export default function LegalLayout({ title, lastUpdate, children }) {
  return (
    <div className="max-w-3xl mx-auto px-4 lg:px-8 py-8 lg:py-16 has-bottom-nav" data-testid="legal-page">
      <Link to="/" className="text-xs label underline">← Retour à l'accueil</Link>
      <header className="mt-4 mb-8 pb-6 border-b-2 border-black">
        <p className="label">Fripri · ECOLOVALO</p>
        <h1 className="text-3xl lg:text-5xl font-black tracking-tighter">{title}</h1>
        {lastUpdate && <p className="text-xs text-[color:var(--color-text-muted)] mt-2">Dernière mise à jour : {lastUpdate}</p>}
      </header>
      <article className="prose prose-sm max-w-none legal-content">
        {children}
      </article>
      <footer className="mt-12 pt-6 border-t-2 border-black/10 text-xs text-[color:var(--color-text-muted)]">
        <p>ECOLOVALO – Association déclarée · SIREN 801 257 593 · 5 Boulevard Galliéni, 92390 Villeneuve-la-Garenne, France</p>
      </footer>
    </div>
  );
}
